export default "/images/vendor/flag-icon-css/flags/4x3/tm.svg?6de6696b70775fd30f3b5a237fceb28c";